export class FilterDisplayBuilder {
  public fragments: IDisplayText[] = [];

  get isEmpty(): boolean {
    return this.fragments.length === 0;
  }

  public appendNormalText(value: string) {
    this.fragments.push(new NormalText(!!value ? value : ''));
  }

  public appendBoldText(value: string) {
    this.fragments.push(new BoldText(!!value ? value : ''));
  }

  public appendColoredText(value: string, color: string) {
    this.fragments.push(new ColoredText(!!value ? value : '', !!color ? color : '#7257ff'));
  }

  public appendTag(value: string) {
    this.fragments.push(new Tag(!!value ? value : ''));
  }

  public buildFilterDisplayHtml(maxLength: number) {
    let fragsToProcess = this.fragments;

    if (maxLength > 0) {
      fragsToProcess = [];
      let currentLength = 0;

      for (let frag of this.fragments) {
        const potentialLength = currentLength + frag.value.length;

        if (potentialLength > maxLength) {
          frag.value = frag.value.substring(0, potentialLength - maxLength);
          fragsToProcess.push(frag);
          fragsToProcess.push(new NormalText('...'));
          break;
        }

        fragsToProcess.push(frag);
        currentLength = potentialLength;
      }
    }

    return fragsToProcess.map(f => f.toHtml()).join(' ');
  }

  public reset() {
    this.fragments = [];
  }
}

export interface IDisplayText {
  toHtml(): void;
  value: string;
}

export class NormalText implements IDisplayText {
  constructor(public value: string) {}

  toHtml(): string {
    return `<span>${encode(this.value)}</span>`;
  }
}

export class BoldText implements IDisplayText {
  constructor(public value: string) {}

  toHtml(): string {
    return `<span><strong>${encode(this.value)}</strong></span>`;
  }
}

export class Tag implements IDisplayText {
  constructor(public value: string) {}

  toHtml(): string {
    return `<span class="filter-pill">${formatMaxLengthString(this.value, 15)}</span>`;
  }
}

export class ColoredText implements IDisplayText {
  constructor(public value: string, private color: string) {}

  toHtml(): string {
    return `<span style="color:${this.color}">${this.value}</span>`;
  }
}

const formatMaxLengthString = (val: string, length: number): string => {
  if (val?.length > length) {
    return encode(`${val.substring(0, length)}...`);
  }

  return encode(val);
};

const encode = (val: string) => {
  return val.replace('<', '&lt;').replace('>', '&gt;');
};
